module.exports = "https://redage.akamaized.net/src/views/player/help/images/street1.jpg";